module.exports = __webpack_public_path__ + "img/sorting.c477d773.svg";